import React, { useState } from "react";
import api, { errMsg } from "@/lib/api";
import { toast } from "sonner";
import { Loader2, KeyRound } from "lucide-react";

export default function AdminPassword() {
  const [oldPw, setOldPw] = useState("");
  const [newPw, setNewPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (newPw.length < 6) return toast.error("Password must be at least 6 characters");
    if (newPw !== confirm) return toast.error("New passwords do not match");
    setLoading(true);
    try {
      await api.post("/admin/change-password", { old_password: oldPw, new_password: newPw });
      toast.success("Password updated");
      setOldPw(""); setNewPw(""); setConfirm("");
    } catch (err) {
      toast.error(errMsg(err, "Failed"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-lg" data-testid="admin-password">
      <p className="overline mb-2">Security</p>
      <h1 className="font-serif text-4xl mb-2">Change your password</h1>
      <p className="text-white/55 text-sm mb-8">
        Verify your current password to set a new one. Your session will remain active.
      </p>

      <form onSubmit={submit} className="card-luxe p-6 space-y-5">
        <div>
          <label className="overline block mb-2">Current Password</label>
          <input type="password" required className="input-luxe" value={oldPw} onChange={(e) => setOldPw(e.target.value)} data-testid="current-password-input" />
        </div>
        <div>
          <label className="overline block mb-2">New Password</label>
          <input type="password" required minLength={6} className="input-luxe" value={newPw} onChange={(e) => setNewPw(e.target.value)} data-testid="new-password-input" />
        </div>
        <div>
          <label className="overline block mb-2">Confirm New Password</label>
          <input type="password" required minLength={6} className="input-luxe" value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="confirm-password-input" />
        </div>

        <div className="flex justify-end">
          <button type="submit" className="btn-primary" disabled={loading} data-testid="change-password-submit">
            {loading ? <Loader2 size={14} className="animate-spin" /> : <KeyRound size={14} />}
            Update Password
          </button>
        </div>
      </form>
    </div>
  );
}
